import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import FooterToolBar from '../../../components/tool/FooterToolBar.vue';
import fanyiPic from '@/assets/fanyi.png';
import { updateAgreementSetting, getAgreementSetting as _getAgreementSetting } from '@/services/systemsetting';
import { upload } from '@/services/common.js';
import TinymceEditor from '@/components/tinymce';
export default {
  components: {
    TinymceEditor: TinymceEditor,
    FooterToolBar: FooterToolBar
  },
  i18n: require('./../i18n-basucSettings'),
  props: ['systemSetting'],
  data: function data() {
    return {
      defaultLangObj: {},
      languageList: [],
      fanyiPic: fanyiPic,
      loadingSave: false,
      tabKey: 0,
      dataForm: {
        dataList: [{
          langId: '',
          languageName: "",
          list: []
        }]
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
    self.languageList = JSON.parse(localStorage.getItem('langList'));
    self.getAgreementSetting();
  },
  methods: {
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      var self = this;
      self.tabKey = activeKey;
      var dataListClone = self.dataForm.dataList;
      var _iterator = _createForOfIteratorHelper(dataListClone),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var _iterator2 = _createForOfIteratorHelper(item.list),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item2 = _step2.value;
              item2.showFY = false;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    showFYBtn: function showFYBtn(obj) {
      var self = this;
      var dataListClone = self.dataForm.dataList;
      var _iterator3 = _createForOfIteratorHelper(dataListClone),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          var _iterator4 = _createForOfIteratorHelper(item.list),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var item2 = _step4.value;
              item2.showFY = false;
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      obj.showFY = true;
    },
    imgUpload: function imgUpload(blobInfo, success, failure) {
      console.log(111);
      var formData = new FormData();
      console.log(blobInfo);
      // formData.type= 6;
      formData.append('type', 6);
      formData.append('file', blobInfo.blob(), blobInfo.filename());
      upload(formData).then(function (res) {
        if (res.data.code == 200) {
          success(res.data.data.urlpath + res.data.data.uploadfilepath);
        } else {
          failure('HTTP Error: ' + res.message);
        }
      });
    },
    initData: function initData() {
      var self = this;
      var dataList = [];
      self.languageList.forEach(function (item) {
        var objDetail = {};
        objDetail.langId = item.langId;
        objDetail.languageName = item.langName;
        //初始化 协议list  协议为空时数据库中不插入，需要初始化
        objDetail.list = [{
          agreementContent: "",
          agreementType: 0,
          id: null,
          showFY: false
        }, {
          agreementContent: "",
          agreementType: 1,
          id: null,
          showFY: false
        },
        // {
        // 	agreementContent:"",
        // 	agreementType:2,
        // 	id:null,
        // 	showFY:false
        // },
        {
          agreementContent: "",
          agreementType: 3,
          id: null,
          showFY: false
        }];
        self.dataForm.dataList.forEach(function (item2) {
          //数据库中有值时，给初始化的list数据赋值
          objDetail.list.forEach(function (item3) {
            /* console.log(item2)
            console.log(item3) */
            if (item.langId == item2.langId) {
              item2.list.forEach(function (item4) {
                if (item3.agreementType == item4.agreementType) {
                  item3.agreementContent = item4.agreementContent;
                  item3.id = item4.id;
                  item3.showFY = false;
                }
              });
            }
          });
        });
        dataList.push(objDetail);
      });
      self.dataForm.dataList = dataList;
    },
    getAgreementSetting: function getAgreementSetting() {
      var _this = this;
      var self = this;
      _getAgreementSetting().then(function (res) {
        if (res.data.code == 200) {
          //获取语言list
          self.dataForm.dataList = res.data.data;
          _this.initData();
        }
      });
    },
    /* 保存 */save: function save() {
      var _this2 = this;
      var self = this;
      self.$refs.dataForm.validate(function (valid) {
        if (valid) {
          self.loadingSave = true;
          updateAgreementSetting(self.dataForm.dataList).then(function (result) {
            if (result.data.code == 200) {
              _this2.$message.success(_this2.$t('public.saveSuccessfully'));
            }
            self.loadingSave = false;
          }).finally(function () {
            self.loadingSave = false;
          });
        } else {
          self.tabKey = 0;
        }
      });
    }
  }
};